import { render, staticRenderFns } from "./TableRMA.vue?vue&type=template&id=cd0bf8da&"
import script from "./TableRMA.vue?vue&type=script&lang=js&"
export * from "./TableRMA.vue?vue&type=script&lang=js&"
import style0 from "./TableRMA.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports